import React, { useState } from 'react';

const MantenedorGrupos = () => {
    // --- DATOS DUMMY ---
    const [grupos, setGrupos] = useState([
        {
            id: 1,
            nombre_grupo: 'Proteínas Sushi',
            tipo_seleccion: 'unica',
            opciones: [
                { id: 101, nombre_opcion: 'Salmón', ajuste_precio: 500 },
                { id: 102, nombre_opcion: 'Camarón', ajuste_precio: 0 }
            ]
        }
    ]);

    const [grupoEditando, setGrupoEditando] = useState(null);

    // --- FUNCIONES ---

    const nuevoGrupo = () => {
        const nuevo = {
            id: Date.now(),
            nombre_grupo: 'Nuevo Grupo',
            tipo_seleccion: 'unica',
            opciones: []
        };
        setGrupos([...grupos, nuevo]);
        setGrupoEditando(nuevo);
    };

    const agregarOpcion = () => {
        const nuevaOp = { id: Date.now(), nombre_opcion: '', ajuste_precio: 0 };
        const editado = Object.assign({}, grupoEditando, { 
            opciones: [...grupoEditando.opciones, nuevaOp] 
        });
        setGrupoEditando(editado);
    };

    const actualizarDatoOpcion = (opId, campo, valor) => {
        const nuevasOps = grupoEditando.opciones.map(function(op) {
            if (op.id === opId) {
                const nuevoObj = {};
                nuevoObj[campo] = valor;
                return Object.assign({}, op, nuevoObj);
            }
            return op;
        });
        setGrupoEditando(Object.assign({}, grupoEditando, { opciones: nuevasOps }));
    };

    const guardarCambios = () => {
        const nuevosGrupos = grupos.map(function(g) {
            return g.id === grupoEditando.id ? grupoEditando : g;
        });
        setGrupos(nuevosGrupos);
        alert("¡Guardado! Ya puedes usar este grupo en tus Rolls.");
        setGrupoEditando(null);
    };

    return (
        <div className="container mt-4">
            <div className="row">
                {/* COLUMNA IZQUIERDA */}
                <div className="col-md-4">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0 fw-bold small">BIBLIOTECA</h6>
                            <button className="btn btn-sm btn-success fw-bold" onClick={nuevoGrupo}>+ NUEVO</button>
                        </div>
                        <div className="list-group list-group-flush">
                            {grupos.map(function(g) {
                                // CAMBIO AQUÍ: Validación manual en lugar de ?.
                                const esActivo = grupoEditando && grupoEditando.id === g.id;
                                return (
                                    <button 
                                        key={g.id} 
                                        type="button"
                                        className={"list-group-item list-group-item-action p-3 " + (esActivo ? 'bg-primary text-white fw-bold' : '')}
                                        onClick={() => setGrupoEditando(g)}
                                    >
                                        {g.nombre_grupo}
                                        <small className="d-block opacity-75" style={{fontSize: '10px'}}>
                                            {g.opciones.length} opciones • {g.tipo_seleccion}
                                        </small>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* COLUMNA DERECHA */}
                <div className="col-md-8">
                    {grupoEditando ? (
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-4">
                                <h5 className="fw-bold mb-4">Editor de Grupo Maestro</h5>
                                
                                <div className="row mb-3">
                                    <div className="col-md-8">
                                        <label className="small fw-bold">NOMBRE DEL GRUPO</label>
                                        <input 
                                            type="text" 
                                            className="form-control fw-bold" 
                                            value={grupoEditando.nombre_grupo} 
                                            onChange={(e) => setGrupoEditando(Object.assign({}, grupoEditando, { nombre_grupo: e.target.value }))}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="small fw-bold">SELECCIÓN</label>
                                        <select 
                                            className="form-select"
                                            value={grupoEditando.tipo_seleccion}
                                            onChange={(e) => setGrupoEditando(Object.assign({}, grupoEditando, { tipo_seleccion: e.target.value }))}
                                        >
                                            <option value="unica">Única</option>
                                            <option value="multiple">Múltiple</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="bg-light p-3 rounded shadow-sm">
                                    <div className="d-flex justify-content-between mb-3">
                                        <h6 className="fw-bold mb-0">Opciones/Ingredientes</h6>
                                        <button className="btn btn-sm btn-outline-primary fw-bold" onClick={agregarOpcion}>+ AGREGAR</button>
                                    </div>

                                    {grupoEditando.opciones.map(function(op) {
                                        return (
                                            <div key={op.id} className="row g-2 mb-2 align-items-center bg-white p-2 rounded mx-0 border">
                                                <div className="col-7">
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm border-0"
                                                        placeholder="Nombre"
                                                        value={op.nombre_opcion}
                                                        onChange={(e) => actualizarDatoOpcion(op.id, 'nombre_opcion', e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text bg-transparent border-0">$</span>
                                                        <input 
                                                            type="number" 
                                                            className="form-control border-0"
                                                            placeholder="Extra"
                                                            value={op.ajuste_precio}
                                                            onChange={(e) => actualizarDatoOpcion(op.id, 'ajuste_precio', e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-1 text-end">
                                                    <button className="btn btn-sm text-danger" onClick={() => {
                                                        const filtradas = grupoEditando.opciones.filter(o => o.id !== op.id);
                                                        setGrupoEditando(Object.assign({}, grupoEditando, { opciones: filtradas }));
                                                    }}>✕</button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="mt-4 d-flex gap-2">
                                    <button className="btn btn-dark btn-lg flex-grow-1 fw-bold rounded-pill" onClick={guardarCambios}>GUARDAR GRUPO</button>
                                    <button className="btn btn-light btn-lg px-4 rounded-pill" onClick={() => setGrupoEditando(null)}>SALIR</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center p-5 bg-light border rounded">
                            <h4 className="text-muted">Selecciona o crea un grupo</h4>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MantenedorGrupos;